/**
 * Component for displaying the playoff tournament bracket for nationals
 * WARNING dummy data
 * Does not currently account for byes, only works for 8 or 4 team brackets
 * Need to be careful with size of names eg only coded to work with LEE B etc
 */
import React from "react";
import { Link } from "react-router-dom";

const PlayoffTeam = ({ id = 0, img, name, blip, score = 0, isWinner = false, isFinal = false }) => {
  return (
    <div className={`flex w-full xxsm:px-2 xxsm:py-1.5 py-1 px-1.5 rounded-md my-1 flex ${(isWinner) ? ((isFinal) ? "dark:bg-green-700 bg-green-400" : "dark:bg-green-900 bg-green-200"): "dark:bg-dark-2 bg-light-2"}`}>
      {/* Team 1 MD+ */}
      <div className={`flex-row w-full justify-between items-center ${isFinal ? "flex" : "md:flex hidden "} `}>
        {(id > 0) ? <img src={`https://buiha.org.uk/assets/img/icon/150/${img}.png`} alt={name} className="md:w-7 md:h-7 h-5 w-5" /> : null}
        <p className={`text-center w-full  ${id > 0 ? "text-smm md:text-sm" : "text-xsm md:text-xs"} xxs:font-semibold xs:mx-1 md:mx-2 leading-tight ${!isWinner ? "text-darken" : ""}`}>{(id > 0) ? blip : name}</p>
        {(id > 0) ? <p className={`text-center text-smm md:text-sm leading-tight ${!isWinner ? "text-darken" : ""}`}>{score}</p> : null}
      </div>
        {/* Team 2 MDHidden */}
        <div className={`flex-row w-full justify-between items-center ${isFinal ? "hidden" : "md:hidden flex "} `}>
        <div className="flex flex-col justify-center w-full mr-2 items-center">
          {(id > 0) ? <img src={`https://buiha.org.uk/assets/img/icon/150/${img}.png`} alt={name} className="md:w-7 md:h-7 h-6 w-6"/> : null}
          <p className={`hidden xxsm:flex text-center text-smm md:text-sm mx-1 mt-1 md:mx-2 leading-tight ${!isWinner ? "text-darken" : ""}`}>{(id > 0) ? blip : name}</p>
        </div>
        {(id > 0) ?<p className={`text-center font-semibold text-smm md:text-sm leading-tight max-xxsm:w-6 ${!isWinner ? "text-darken" : ""}`}>{score}</p> : null}
        </div>
    </div>
  );
};

export default PlayoffTeam;
